// Virement.js
import React, { useState } from 'react';
import MenuClient from '../Components/menuclient';

const Virement = () => {
  const [form, setForm] = useState({
    montant: '',
    beneficiaire: '',
    iban: '',
    swift: '',
    banque: '',
    raison: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Fonction de test uniquement. Aucune transaction réelle.');
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h2 style={styles.title}>Effectuer un virement</h2>
        <p style={styles.solde}>Solde disponible : <strong>10 000,00 €</strong></p>
      </div>

      <form style={styles.form} onSubmit={handleSubmit}>
        <label style={styles.label}>Montant du virement</label>
        <div style={styles.inputGroup}>
          <input type="number" name="montant" placeholder="0.00" value={form.montant} onChange={handleChange} style={styles.input} />
          <span style={styles.euro}>€</span>
        </div>

        <label style={styles.label}>Nom du bénéficiaire</label>
        <input type="text" name="beneficiaire" value={form.beneficiaire} onChange={handleChange} style={styles.input} />

        <label style={styles.label}>IBAN / Numéro de Compte</label>
        <input type="text" name="iban" value={form.iban} onChange={handleChange} style={styles.input} />

        <label style={styles.label}>Code Banque (BIC / SWIFT)</label>
        <input type="text" name="swift" value={form.swift} onChange={handleChange} style={styles.input} />

        <label style={styles.label}>Nom de la Banque</label>
        <input type="text" name="banque" value={form.banque} onChange={handleChange} style={styles.input} />

        <label style={styles.label}>Raison du virement</label>
        <input type="text" name="raison" value={form.raison} onChange={handleChange} style={styles.input} />

        <button type="submit" style={styles.button}>Continuer →</button>
      </form>

      <MenuClient />
    </div>
  );
};

const styles = {
  page: {
    padding: '20px',
    paddingBottom: '80px',
    fontFamily: 'Arial, sans-serif',
  },
  header: {
    marginBottom: '20px',
  },
  title: {
    fontSize: '20px',
    marginBottom: '10px',
  },
  solde: {
    fontSize: '16px',
    marginBottom: '10px',
  },
  warning: {
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeeba',
    padding: '10px',
    borderRadius: '6px',
    color: '#856404',
    fontSize: '14px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  inputGroup: {
    position: 'relative',
  },
  euro: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#555',
  },
  input: {
    padding: '10px',
    paddingRight: '30px',
    fontSize: '14px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    width: '100%',
    boxSizing: 'border-box',
  },
  button: {
    marginTop: '20px',
    padding: '12px',
    backgroundColor: '#0061A6',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    cursor: 'pointer',
  },
};

export default Virement;
